// =============================================================================
// Auto-Switch zum 2. Produktbild bei erster Customizer-Interaktion
// =============================================================================
//
// Eigenständiges Mini-Skript, isoliert von custom-designer.js. Sobald der
// Kunde anfängt, sein Design zu definieren (KI-Panel öffnen, Bild hochladen,
// Wunschtext tippen, Position/Größe wählen), wechselt die Produkt-Galerie
// automatisch vom 1. Bild (Modelfoto) zum 2. Bild (Freisteller).
//
// Architektur — bewusst über Event-Delegation auf `document`:
//   - Wir hängen EINEN einzigen Click/Input/Change-Listener auf `document`
//   - Bei jedem Event prüfen wir, ob das Target zu einem Customizer-Trigger gehört
//   - So funktioniert es AUCH wenn die Trigger-Elemente erst NACH dem Page-Load
//     im DOM auftauchen (z.B. durch Theme-Section-Re-Render)
//
// Komplett ISOLIERT — try/catch um ALLES, niemals propagierte Errors.
//
// 2026-05-22 — Laurelle's-Customizer
// =============================================================================

(function () {
  'use strict';

  const LOG_PREFIX = '[Laurelles Image Switcher]';

  // Selektoren, deren Klick/Input einen Galerie-Switch auslöst.
  // Bewusst als Array, damit wir jederzeit weitere hinzufügen können.
  const TRIGGER_SELECTORS = {
    click: [
      '#aiPanelToggleBtn',
      '#aiGenerateBtn',
      '#aiUseOnProductBtn',
      '.position-btn',
      '.size-step-btn',
    ],
    change: [
      '#imageUpload',
    ],
    input: [
      '#customText',
    ],
  };

  let hasSwitched = false;
  let initDone = false;

  function safeInit() {
    try {
      init();
    } catch (e) {
      console.warn(LOG_PREFIX + ' Init fehlgeschlagen — Customizer läuft unbeeinflusst weiter.', e);
    }
  }

  function init() {
    if (initDone) return;

    // Nur auf Seiten aktiv, die einen Customizer rendern.
    if (!document.querySelector('.custom-design-options')) {
      console.log(LOG_PREFIX + ' Kein Customizer auf dieser Seite — skip.');
      return;
    }

    initDone = true;
    console.log(LOG_PREFIX + ' Initialisiert. Lausche auf Customizer-Interaktionen...');

    // ---- Event-Delegation auf document ----
    // Vorteil: funktioniert auch wenn die Trigger-Elemente erst nach Page-Load
    // im DOM erscheinen (z.B. KI-Panel wird dynamisch geöffnet).
    ['click', 'change', 'input'].forEach(function (eventType) {
      document.addEventListener(eventType, function (e) {
        if (hasSwitched) return;
        const target = e.target;
        if (!target || !target.closest) return;

        const selectors = TRIGGER_SELECTORS[eventType] || [];
        for (let i = 0; i < selectors.length; i++) {
          if (target.matches && target.matches(selectors[i])) {
            console.log(LOG_PREFIX + ' Trigger erkannt: ' + selectors[i] + ' (event=' + eventType + ')');
            doSwitch();
            return;
          }
          // Auch closest() prüfen, falls ein Child geklickt wurde (z.B. <img> in Button)
          if (target.closest(selectors[i])) {
            console.log(LOG_PREFIX + ' Trigger über closest(): ' + selectors[i] + ' (event=' + eventType + ')');
            doSwitch();
            return;
          }
        }
      }, true); // capture phase, damit wir vor anderen Listenern dran sind
    });
  }

  function doSwitch() {
    if (hasSwitched) return;
    hasSwitched = true;

    // Verzögert, damit eventuelle andere Klick-Handler erstmal durchlaufen
    setTimeout(function () {
      try {
        switchGalleryToImage(2);
      } catch (e) {
        console.warn(LOG_PREFIX + ' Switch fehlgeschlagen:', e);
      }
    }, 50);
  }

  function switchGalleryToImage(targetIndex) {
    // targetIndex = 1-basiert (1 = erstes Bild, 2 = zweites Bild)
    console.log(LOG_PREFIX + ' Versuche Switch auf Bild #' + targetIndex + '...');

    // STRATEGIE 1: Dawn's <media-gallery>-Komponente mit setActiveMedia()
    const gallery = document.querySelector('media-gallery');
    if (gallery) {
      console.log(LOG_PREFIX + ' <media-gallery> gefunden.');
      const viewer = gallery.querySelector('[id^="GalleryViewer"]')
                  || gallery.querySelector('.product__media-list')
                  || gallery;
      const allMedia = viewer.querySelectorAll('[data-media-id]');
      console.log(LOG_PREFIX + ' Anzahl Medien im Viewer: ' + allMedia.length);

      if (allMedia.length >= targetIndex && typeof gallery.setActiveMedia === 'function') {
        const targetMediaId = allMedia[targetIndex - 1].dataset.mediaId;
        console.log(LOG_PREFIX + ' setActiveMedia(' + targetMediaId + ', false)');
        gallery.setActiveMedia(targetMediaId, false);
        return;
      }

      // Fallback A: Klick aufs Thumbnail
      const thumbButtons = gallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target] button, .thumbnail-list__item button');
      if (thumbButtons.length >= targetIndex) {
        console.log(LOG_PREFIX + ' Fallback A: Klick auf Thumbnail #' + targetIndex);
        thumbButtons[targetIndex - 1].click();
        return;
      }
    }

    // STRATEGIE 2: Generischer Slider (slider-component)
    const slider = document.querySelector('slider-component, #GalleryViewer-' + (typeof window.sectionId === 'string' ? window.sectionId : ''));
    if (slider && typeof slider.scrollTo === 'function') {
      console.log(LOG_PREFIX + ' Fallback B: scrollTo Slide');
      const slides = slider.querySelectorAll('.slider__slide, [data-media-id]');
      if (slides.length >= targetIndex) {
        const slide = slides[targetIndex - 1];
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        return;
      }
    }

    // STRATEGIE 3: Letzter Notfall — alle Thumbnails im Body klicken
    const anyThumbs = document.querySelectorAll('.product__media-list [data-media-id], .product__media-item');
    if (anyThumbs.length >= targetIndex) {
      console.log(LOG_PREFIX + ' Fallback C: Klick auf product__media-item #' + targetIndex);
      // Klick auf zugehöriges Thumbnail-Button
      const targetMediaItem = anyThumbs[targetIndex - 1];
      const correspondingThumb = document.querySelector('[data-target="' + targetMediaItem.dataset.mediaId + '"] button');
      if (correspondingThumb) {
        correspondingThumb.click();
        return;
      }
    }

    console.warn(LOG_PREFIX + ' Keine geeignete Strategie gefunden. Galerie-Struktur evtl. nicht Dawn-kompatibel.');
  }

  // ---- Init-Trigger: möglichst früh + möglichst robust ----
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    // Bereits geladen — sofort
    safeInit();
  }
  // Backup: load (falls DOMContentLoaded zu früh war)
  window.addEventListener('load', safeInit);
})();
